export const userColumns = [
  { title: "ID", width: "60px" },
  { title: "Ime" },
  { title: "Prezime" },
  { title: "Korisničko ime" },
  { title: "E-mail" },
  { title: "Status", width: "120px" },
  { title: "Akcije", width: "100px" },
];
